module.exports = __webpack_public_path__ + "static/media/cv.b40ecf03.pdf";